"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const AuthBox_1 = require("../AuthBox");
require("./UserNotFoundMessage.css");
function UserNotFoundMessage({ email, }) {
    const { userNotFoundExplanation, setAuthBoxState, setAuthenticationDetails, } = (0, AuthBox_1.useAuthBoxContext)();
    const gotoSignUp = (0, react_1.useCallback)(() => {
        setAuthenticationDetails({ email });
        setAuthBoxState(AuthBox_1.AuthBoxState.SIGN_UP);
    }, [setAuthBoxState]);
    return (react_1.default.createElement("div", { id: "user-not-found-message" },
        react_1.default.createElement("p", { className: "error-message" },
            "No account found for ",
            react_1.default.createElement("strong", null, email)),
        react_1.default.createElement("p", { className: "register-message" },
            "Would you like to",
            " ",
            react_1.default.createElement("span", { className: "link", onClick: gotoSignUp }, "register"),
            " ",
            "instead?"),
        userNotFoundExplanation));
}
exports.default = UserNotFoundMessage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVXNlck5vdEZvdW5kTWVzc2FnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91aS9zaGFyZWQvVXNlck5vdEZvdW5kTWVzc2FnZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLCtDQUEyQztBQUMzQyx3Q0FBNkQ7QUFDN0QscUNBQW1DO0FBTW5DLFNBQXdCLG1CQUFtQixDQUFDLEVBQzFDLEtBQUssR0FDcUI7SUFDMUIsTUFBTSxFQUNKLHVCQUF1QixFQUN2QixlQUFlLEVBQ2Ysd0JBQXdCLEdBQ3pCLEdBQUcsSUFBQSwyQkFBaUIsR0FBRSxDQUFDO0lBRXhCLE1BQU0sVUFBVSxHQUFHLElBQUEsbUJBQVcsRUFBQyxHQUFHLEVBQUU7UUFDbEMsd0JBQXdCLENBQUMsRUFBRSxLQUFLLEVBQUUsQ0FBQyxDQUFDO1FBQ3BDLGVBQWUsQ0FBQyxzQkFBWSxDQUFDLE9BQU8sQ0FBQyxDQUFDO0lBQ3hDLENBQUMsRUFBRSxDQUFDLGVBQWUsQ0FBQyxDQUFDLENBQUM7SUFFdEIsT0FBTyxDQUNMLHVDQUFLLEVBQUUsRUFBQyx3QkFBd0I7UUFDOUIscUNBQUcsU0FBUyxFQUFDLGVBQWU7O1lBQ0wsOENBQVMsS0FBSyxDQUFVLENBQzNDO1FBQ0oscUNBQUcsU0FBUyxFQUFDLGtCQUFrQjs7WUFDWCxHQUFHO1lBQ3JCLHdDQUFNLFNBQVMsRUFBQyxNQUFNLEVBQUMsT0FBTyxFQUFFLFVBQVUsZUFFbkM7WUFBQyxHQUFHO3VCQUVUO1FBQ0gsdUJBQXVCLENBQ3BCLENBQ1AsQ0FBQztBQUNKLENBQUM7QUE3QkQsc0NBNkJDIn0=